import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import SpeciesPage from './components/SpeciesPage';

/**
 * /species/:id's own discussion list is filtered by species, not by tag
 * (see SpeciesFilter) - unlike every other discussion list on the site,
 * which is already scoped to one tag and had its tag label removed as
 * redundant there (see champis-forum's own simplifyDiscussionListItem.js),
 * one row here can belong to any forum, so which one it is is genuinely
 * useful information. Re-added only on this page, as its own line below the
 * species name - gated on app.current.matches() rather than a prop threaded
 * through DiscussionList, since core's own DiscussionList.js instantiates
 * DiscussionListItem directly with no such extension seam.
 */
export default function addSpeciesDiscussionForum() {
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    if (!app.current.matches(SpeciesPage)) return;
    const allTags = this.attrs.discussion.tags ? this.attrs.discussion.tags() || null : null;
    if (!allTags || !allTags.length) return;

    // Prefer the actual subforum(s) (any tag with a parent) over the root
    // category umbrella they sit under (e.g. "Champignons") - matching
    // addForumsMenu.js's own distinction between real, clickable forums and
    // unclickable group headers there. Falls back to the root tag itself
    // for the rare discussion tagged with only one, rather than showing
    // nothing.
    const withParent = allTags.filter(tag => tag && tag.parent());
    const tags = withParent.length ? withParent : allTags;
    items.add('champisSpeciesForum', m("span", {
      className: "DiscussionListItem-forum"
    }, tags.map((tag, i) => tag && m("span", {
      key: tag.id()
    }, i > 0 && ' · ', m(Link, {
      href: app.route.tag(tag)
    }, tag.name())))),
    // Below the species item (10, see champis-species' own
    // addSpeciesLabels.js) so it renders as the next line down.
    9);
  });
}